"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var Invoice32 = function (props) { return (react_1.default.createElement("svg", __assign({ viewBox: "0 0 32 32", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" }, props),
    react_1.default.createElement("path", { d: "M19 5a1 1 0 01.707.293l5 5A1 1 0 0125 11v14a1 1 0 01-1 1H8a1 1 0 01-1-1V6a1 1 0 011-1h11zm-1 1H8v19h16V12h-5.5a.5.5 0 01-.5-.5V6zm3.5 15a.5.5 0 010 1h-11a.5.5 0 010-1zm0-3a.5.5 0 010 1h-11a.5.5 0 010-1zm0-3a.5.5 0 010 1h-11a.5.5 0 010-1zm-8.89-7c.843 0 1.32.387 1.686.912l-.643.476c-.297-.407-.58-.628-1.063-.628-.49 0-.87.324-1.064.842h1.485v.587h-1.616c-.014.097-.014.2-.014.304 0 .097 0 .187.007.276h1.623v.594h-1.492c.194.546.587.877 1.126.877.463 0 .739-.241 1.057-.663l.607.45c-.393.572-.884.973-1.67.973-1.023 0-1.741-.656-2.01-1.637H10v-.594h.532c-.007-.083-.007-.172-.007-.262 0-.104 0-.214.014-.318H10v-.587h.65C10.924 8.67 11.63 8 12.61 8zM19 6v5h5l-5-5z", className: "invoice-32_svg__path-1" }))); };
var StyledInvoice32 = styled_components_1.default(Invoice32)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: ", ";\n  height: ", ";\n  color: ", ";\n  vertical-align: middle;\n  fill: ", ";\n\n  ", "\n"], ["\n  width: ", ";\n  height: ", ";\n  color: ", ";\n  vertical-align: middle;\n  fill: ", ";\n\n  ", "\n"])), function (_a) {
    var _b = _a.size, size = _b === void 0 ? '32px' : _b;
    return size;
}, function (_a) {
    var _b = _a.size, size = _b === void 0 ? '32px' : _b;
    return size;
}, function (_a) {
    var color = _a.color, theme = _a.theme;
    return color || theme.base.color.text;
}, function (_a) {
    var color = _a.color, theme = _a.theme;
    return color || theme.base.color.text;
}, function (_a) {
    var stroke = _a.stroke;
    return stroke && "stroke: " + stroke + "; stroke-width: 64;";
});
exports.default = StyledInvoice32;
var templateObject_1;
//# sourceMappingURL=Invoice32.js.map